import styled from "styled-components";

export const MapEmbedIframe = styled.iframe`
  max-width: calc(calc(100vw - var(--outsidePadding)) - var(--outsidePadding));
`;
